import { Box, Typography, useTheme } from '@mui/material';
import { tokens } from '../../global/theme/tokens';
import { useTranslation } from 'react-i18next';

export const ChatTypingIndicator = ({ typingUsers }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();

  const users = typingUsers ? Object.values(typingUsers) : [];
  if (users.length === 0) return null;

  const getText = () => {
    if (users.length === 1) {
      return t('{{name}} is typing...', { name: users[0] });
    }
    if (users.length === 2) {
      return t('{{name1}} and {{name2}} are typing...', { name1: users[0], name2: users[1] });
    }
    return t('{{count}} people are typing...', { count: users.length });
  };

  return (
    <Box className="px-4 py-1" sx={{ minHeight: 20 }}>
      <Box className="flex items-center gap-2">
        <Box className="flex gap-0.5">
          {[0, 1, 2].map((i) => (
            <Box
              key={i}
              sx={{
                width: 4,
                height: 4,
                borderRadius: '50%',
                backgroundColor: colors.info,
                opacity: 0.7,
                animation: 'typing-dot 1.4s infinite',
                animationDelay: `${i * 0.2}s`,
                '@keyframes typing-dot': {
                  '0%, 60%, 100%': {
                    transform: 'translateY(0)',
                  },
                  '30%': {
                    transform: 'translateY(-3px)',
                  },
                },
              }}
            />
          ))}
        </Box>
        <Typography variant="caption" sx={{ color: colors.text, opacity: 0.5, fontSize: '0.7rem' }}>
          {getText()}
        </Typography>
      </Box>
    </Box>
  );
};
